import { IsNotEmpty, IsValidNumberOrPercentage } from '@core/services/csv/CSVCustomValidator'
import { Expose } from 'class-transformer'

import { IntermediaryCsvModel } from './IntermediaryCsvModel'

export class IntroducerCsvModel extends IntermediaryCsvModel {
  filename = 'IntroducerCSVTemplate'

  static ifamList: Array<{
    oid: string;
    nric: string;
    email: string;
    name: string;
  }> = []

  static nonIfam: Array<{
    oid: string;
    nric: string;
    email: string;
    name: string;
  }> = []

  @Expose()
  @IsNotEmpty()
  @IsValidNumberOrPercentage('Year 1 Commission')
  private 'Year 1 Commission (S$ / %)' = '123.45 / 10%'

  get year1Commission () {
    return this['Year 1 Commission (S$ / %)']
  }

  @Expose()
  @IsNotEmpty()
  @IsValidNumberOrPercentage('Renewal Commission')
  private 'Renewal Commission (S$ / %)' = '123.45 / 10%'

  get renewalCommission () {
    return this['Renewal Commission (S$ / %)']
  }

  get userSystemOid () {
    const list = this.isIfamUser ? IntroducerCsvModel.ifamList : IntroducerCsvModel.nonIfam
    return list.find(e => e.nric === this.nric)?.oid
  }

  get email () {
    const list = this.isIfamUser ? IntroducerCsvModel.ifamList : IntroducerCsvModel.nonIfam
    return list.find(e => e.nric === this.nric)?.email
  }

  get name () {
    const list = this.isIfamUser ? IntroducerCsvModel.ifamList : IntroducerCsvModel.nonIfam
    return list.find(e => e.nric === this.nric)?.name
  }
}
